<template>
  <section class="content-header">
    <h1>{{ title }}</h1>

    <ol class="breadcrumb">
      <li>
        <router-link :to="{ name: 'dashboard' }">
          <i class="fa fa-dashboard"></i> Home
        </router-link>
      </li>
      <li v-for="item in breadcrumbs">
        <router-link :to="{ name: item.link }">
          {{ item.name }}
        </router-link>
      </li>
      <li class="active">
        <span v-if="isCreate">Create</span>
        <span v-else>Edit</span>
      </li>
    </ol>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },

    breadcrumbs: {
      type: Array,
      required: false,
    },

    isCreate: {
      type: Boolean,
      required: false,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/common/ContentHeader.vue